import React from 'react';
import PropTypes from 'prop-types';
import './Column.scss';

const Column = props => {
  return (
    <div
      className="grid__column"
      style={{
        flexBasis: props.desktopUp && props.desktopWidth,
        margin: props.desktopUp && `0 ${props.desktopMargin}`
      }}>
      {props.items}
    </div>
  );
};


Column.propTypes = {
  desktopWidth: PropTypes.string.isRequired,
  desktopMargin: PropTypes.string.isRequired,
  desktopUp: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.node.isRequired).isRequired
};

export default Column;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Column/Column.js